import { INotification } from "../components/mike-notification-list";
import ActionType from "./ActionType";

export const setNotification = (notifications: INotification[]) => ({
  type: ActionType.SET_NOTIFICATION,
  data: notifications
})
